export default __webpack_public_path__ + "static/media/googlePlay.673427c7.png";